<template>
  <client-only>
    <aside aria-hidden="true">
      <span>{{ flag }}</span>
      <span title="Page has no title defined" class="beat" style="background-color:#e53935" v-if="!info.title"></span>
      <span title="Page has no description defined" class="beat" style="background-color:#009688"
        v-if="!info.description"></span>
      <span title="Page has no keywords defined" class="beat" style="background-color:#7b1fa2"
        v-if="!info.keywords"></span>
      <span title="Inspect elements/hierarchy" @click="toggleDebug"><cms-material-icon class="accent" size="normal"
          icon="find_in_page" style="cursor: pointer;color:goldenrod"></cms-material-icon></span>
      <!-- <span title="Quick toggle dark mode" @click="toggleDark" style="cursor: pointer;">🌖</span> -->
    </aside>
  </client-only>
</template>
<script>
export default {
  name: "cms-seo-health",
  props: ["info"],
  methods: {
    toggleDebug() {
      document.querySelector('.cms-page').classList.toggle("debug");
    },
    toggleDark() {
      const root = document.getElementsByTagName('html')[0];
      root.classList.toggle("dark")
      this.$root.$emit("mode:dark", root.classList.contains("dark"))
      // document.querySelector('meta[name="theme-color"]').setAttribute('content', root.classList.contains("dark") ? '#1D2127' : "#010034");
    },
  },
  computed: {
    flag() {
      const flags = { en: '🇪🇺', de: '🇨🇭', it: '🇮🇹', fr: '🇫🇷' }
      return flags[this.$store.state.language || "en"]
    }
  }
}
</script>

<style scoped>
aside {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 100px;
  right: 16px;
  z-index: 9999;
  user-select: none;
}

aside>span.beat {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-block: 3px;
}

aside>span:not(.beat) span {
  cursor: pointer !important;
}

aside>span.beat {
  animation: heartbeat 2s infinite;
}

@keyframes heartbeat {
  0% {
    transform: scale(.75);
  }

  20% {
    transform: scale(1);
  }

  40% {
    transform: scale(.75);
  }

  60% {
    transform: scale(1);
  }

  80% {
    transform: scale(.75);
  }

  100% {
    transform: scale(.75);
  }
}
</style>
